import AccountPage from './AccountPage';

export default function ProfilePage() {
  return <AccountPage />;
}
